// @flow

import styled from 'styled-components';
import { theme } from '../theme';

export const RadioButton = styled.input.attrs({ type: 'radio' })`
  position: relative;
  height: 18px;
  width: 18px;
  appearance: none;
  cursor: pointer;
  border: 1px solid ${theme.colors.gray(85)};
  border-radius: 50%;
  transition: all 0.2s ease-in-out;

  &:checked {
    box-shadow: 0 0 0 10px ${theme.colors.blue(40)} inset;
    border: none;

    &::after {
      content: "";
      position: absolute;
      width: 4px;
      height: 4px;
      margin-top: -2px;
      margin-left: -2px;
      background: ${theme.colors.white(100)};
      top: 50%;
      left: 50%;
      transition: all 0.2s ease-in-out 0.1s;
      border-radius: 50%;
    }
  }
`;
